import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/footer-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneAuthProvider"] */ "/vercel/path0/components/phone-auth-context.tsx");
